import { render } from "./add.vue?vue&type=template&id=79f0233c&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=79f0233c&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f0233c"]])

export default __exports__